import apolloClient from 'apollo/sofarApolloClient';

import {
  CreateOrderApiResponse,
  CreateOrderParameters,
  PromoCodeWithCharges,
} from 'app/shared/typings';
import { CREATE_ORDER } from 'app/fan/graphql/orders/mutations';

interface Props {
  billingRegion: string;
  stripePaymentId?: string;
  eventId: string;
  numTickets: number;
  promoCode?: PromoCodeWithCharges;
  isVisaFreeTicketRedeemed?: boolean;
  checkoutVersion?: number;
  isExpressCheckout?: boolean;
  guestUserId?: number;
}
/**
 * This method calls the createOrder endpoint on our api which will finalise
 * the payment, add the user to the event attendees etc
 */
const completeOrder = async ({
  billingRegion,
  stripePaymentId = '',
  eventId,
  numTickets,
  promoCode,
  isVisaFreeTicketRedeemed = false,
  checkoutVersion = 1,
  isExpressCheckout = false,
  guestUserId,
}: Props) => {
  return apolloClient.mutate<CreateOrderApiResponse, CreateOrderParameters>({
    mutation: CREATE_ORDER,
    variables: {
      billingRegion,
      stripePaymentId,
      eventId,
      numTickets,
      promoCodeCode: promoCode ? promoCode.promoCode.code : null,
      isVisaFreeTicketRedeemed,
      checkoutVersion,
      isExpressCheckout,
      guestUserId,
    },
  });
};

export default completeOrder;
